const setSize = () => {
	const gameHolder = document.querySelector('.featured-game__holder');
	if (gameHolder) {
		const header = document.querySelector('.header');
		const gameHeading = document.querySelector('.featured-game__heading');
		const gameContainer = document.querySelector('.featured-game');
		
		if (document.documentElement.clientWidth >= 1024) {
			let gameHolderHeight = document.documentElement.clientHeight
				- header.clientHeight - gameHeading.clientHeight
				- parseInt(getComputedStyle(gameHeading).marginBottom)
				- parseInt(getComputedStyle(gameContainer).paddingTop);
			
			let gameHolderWidth = gameHolderHeight * 1.51;
			if (gameHolderWidth >= document.documentElement.clientWidth - 100) {
				gameHolderWidth = document.documentElement.clientWidth - 100;
				gameHolderHeight = gameHolderWidth / 1.51;
			}
			
			gameHeading.style.width = `${gameHolderWidth}px`;
			gameHolder.style.height = `${gameHolderHeight}px`;
			gameHolder.style.width = `${gameHolderWidth}px`;
			gameContainer.classList.add('featured-game--active')
		} else {
			gameHeading.style.cssText = '';
			gameHolder.style.cssText = '';
		}
	}
};

const setFeaturedGameSize = () => {
	window.addEventListener('load', (evt) => {
		setSize();
		window.addEventListener('resize', setSize);
	});
};

export default setFeaturedGameSize;
